import script from "./Titulo.vue?vue&type=script&setup=true&lang=js"
export * from "./Titulo.vue?vue&type=script&setup=true&lang=js"

import "./Titulo.vue?vue&type=style&index=0&id=a62c2000&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a62c2000"]])

export default __exports__